import { render, staticRenderFns } from "./DataPrivacy.vue?vue&type=template&id=30a308d2"
import script from "./DataPrivacy.vue?vue&type=script&lang=ts"
export * from "./DataPrivacy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports